import mills from "../../../../src/docs/credits/logo/logo.svg";
import * as React from 'react';
export default {
  mills,
  React
};